import React, { Component } from 'react';
// import data from '../assets/json/about.json';

// Create a context with default values
export const DataContext = React.createContext({});

// This is the consumer of the values (state)
export const DataConsumer = DataContext.Consumer;

export class DataProvider extends Component {
  state = {
    links: [
      'about',
      'hero',
      'nav',
      'experience',
      'contact'
    ]
  }

  componentDidMount() {
    // this.getData();
  }

  getData = () => {
    this.setState({
      loading: true
    });
    setTimeout(() => {
      this.setState({
        loading: false
      });
    }, 4000);
  }

  render() {
    return (
      <DataContext.Provider
        value={{
          data: this.state,
          get: this.getData
        }}
        >
        {this.props.children}
      </DataContext.Provider>
    )
  }
}



// WEBPACK FOOTER //
// ./src/context/DataContext.js